import { render, staticRenderFns } from "./CalcBox.vue?vue&type=template&id=8537b39a&scoped=true&"
import script from "./CalcBox.vue?vue&type=script&lang=js&"
export * from "./CalcBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8537b39a",
  null
  
)

export default component.exports